import { useEffect, useRef, useState } from "react";

interface ExpandableTextProps {
  text: string;
  lines: number;
  expandTestId?: string;
}

const ExpandableText = (props: ExpandableTextProps) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [clamped, setClamped] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const checkClamp = () => {
      const element = textRef.current;
      if (element) {
        const currentStyle = window.getComputedStyle(element);
        const lineClamp = parseInt(currentStyle.getPropertyValue('-webkit-line-clamp'));

        if (lineClamp > 0 && currentStyle.getPropertyValue('overflow') === 'hidden')
          setClamped(element.scrollHeight > element.clientHeight);
        else
          setClamped(false);
      }
    }

    checkClamp();

    window.addEventListener('resize', checkClamp);
    return () => window.removeEventListener('resize', checkClamp);
  }, [props.text])

  return <>
    {clamped && <button data-testid={props.expandTestId} className="btn btn-ghost-secondary p-1" onClick={() => setExpanded(!expanded)}>
      {expanded ? <i className="bi bi-chevron-compact-up"></i> : <i className="bi bi-chevron-compact-down"></i>}
    </button>}
    <div
      ref={textRef}
      style={expanded ? undefined : {
        display: '-webkit-box',
        WebkitLineClamp: props.lines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {props.text}
    </div>
  </>
}

export default ExpandableText;
